import React from "react";
import { useLocation } from "react-router-dom";
import SEOHead from "../ui/SEOHead";
import metadata from "../../public-metadata.json";
export default function PublicMetadata() {
  const { pathname } = useLocation();
  const authorHost = window.location.hostname.endsWith(".bookishcircle.com") && window.location.hostname !== "www.bookishcircle.com";
  if (authorHost) return null;
  const page = metadata[pathname.replace(/\/$/, "") || "/"] || metadata["/"];
  return <SEOHead {...page} image="https://bookishcircle.com/social-preview.png" url={"https://bookishcircle.com" + pathname} />;
}
